import { getValidationResolver, useForm } from '@common-fe/common-fe';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { AUTH_ERROR_KEY, REQUIRED_TEXT } from '@/common/constants';

export enum CreateMainContactField {
  firstName = 'firstName',
  lastName = 'lastName',
  personalEmail = 'personalEmail',
  username = 'username',
  phoneNumber = 'phoneNumber',
  password = 'password',
  confirmPassword = 'Confirm password',
  isPricingConsentAgreed = 'isPricingConsentAgreed',
  isPrivacyPolicyAgreed = 'isPrivacyPolicyAgreed',
}

export interface CreateMainContactForm {
  [CreateMainContactField.firstName]: string;
  [CreateMainContactField.lastName]: string;
  [CreateMainContactField.personalEmail]: string;
  [CreateMainContactField.username]: string;
  [CreateMainContactField.phoneNumber]: string;
  [CreateMainContactField.password]: string;
  [CreateMainContactField.confirmPassword]: string;
  [CreateMainContactField.isPricingConsentAgreed]: boolean;
  [CreateMainContactField.isPrivacyPolicyAgreed]: boolean;
}

const useCreateMainContactForm = () => {
  const methods = useForm<CreateMainContactForm>({
    resolver: getValidationResolver({
      [CreateMainContactField.firstName]: VALIDATORS.REQUIRED_STRING,
      [CreateMainContactField.lastName]: VALIDATORS.REQUIRED_STRING,
      [CreateMainContactField.personalEmail]: VALIDATORS.EMAIL_REQUIRED,
      [CreateMainContactField.username]: VALIDATORS.USER_NAME,
      [CreateMainContactField.phoneNumber]: VALIDATORS.PHONE_NUMBER_VALIDATE.required(REQUIRED_TEXT),
      [CreateMainContactField.password]: VALIDATORS.PASSWORD,
      [CreateMainContactField.confirmPassword]:yup.string().required(AUTH_ERROR_KEY.PASSWORD_IS_REQUIRED)
        .oneOf([yup.ref(CreateMainContactField.password)], AUTH_ERROR_KEY.PASSWORD_DO_NOT_MATCH),
      [CreateMainContactField.isPricingConsentAgreed]: VALIDATORS.BOOLEAN_REQUIRED.isTrue(),
      [CreateMainContactField.isPrivacyPolicyAgreed]: VALIDATORS.BOOLEAN_REQUIRED.isTrue(),
    })
  });

  return { methods };
};

export default useCreateMainContactForm;
